import React from "react";
import DefaultLayout from "../layouts/Default";
import CardPopUp from "../utils/CardPopUp";
import Slider from "../utils/Slider";
import Image from "../utils/Image";
import TitleCar from "../utils/TitleCar";
import styled from "styled-components";

const images = require.context("../../assets/img/", true);

const Grid2 = styled.div`
  display: grid;
  margin-top: 2rem;
  grid-template-columns: 48% 48%;
  column-gap: 4%;
  row-gap: 2rem;
`;

const MainBanner = () => {
  const sliders = [
    { imageURL: "./banner1.png" },
    { imageURL: "./banner1.png" },
  ];

  return (
    <Slider
      data={sliders.map((item, index) => (
        <Image
          key={index}
          src={images(item.imageURL)}
          alt={`Banner #${index + 1} de la pagina web`}
          classNameDiv="p-0"
          classNameImg="w-100"
        ></Image>
      ))}
      id="slider-banner"
      classItems="w-100"
    />
  );
};

const QuienesSomos = () => {
  return (
    <DefaultLayout>
      {/* <MainBanner /> */}
      <div className="row justify-content-center ">
        <div className="row col-11 col-lg-9 my-4">
          <div className="col-12 py-3">
            <TitleCar>
              <b>Quiénes somos</b>
            </TitleCar>

            <div className="py-4 mt-5">
              <CardPopUp
                title="¿QUÉ ES EL BANCO DE PROGRAMAS Y PROYECTOS DE INVERSIÓN BPPI-CAR?"
                description="Conoce más aquí"
                iconSrc={"./documentHands.png"}
              >
                <div
                  style={{
                    maxWidth: "1000px",
                    maxHeight: "700px",
                    overflow: "scroll",
                  }}
                  className="fs-responsive-m"
                >
                  Se establece como un sistema de Información que consolida los
                  Programas, Proyectos, Metas y Actividades que comprenden los
                  instrumentos de planificación de largo, mediano y corto plazo,
                  de la Corporación Autónoma Regional CAR; a saber, el Plan de
                  Gestión Ambiental Regional PGAR, el Plan de Acción Cuatrienal
                  PAC y el presupuesto anual de rentas y gastos; y contemplando
                  la estructura de formulación, programación de inversión y
                  ejecución y seguimiento del gasto de inversión. Así mismo,
                  consolida las acciones (proyectos internos, de cofinanciación,
                  de cooperación y de emergencia) que se derivan del
                  cumplimiento de las actividades del plan de acción cuatrienal
                  PAC. <br />
                  <br />
                  El Banco de Programas y Proyectos de Inversión CAR BPPI-CAR,
                  se fundamenta en las directrices impartidas por el Ministerio
                  de Ambiente y Desarrollo Sostenible MADS, y establece que, con
                  base en los programas y proyectos definidos en el Plan de
                  Acción Cuatrienal PAC, las Corporaciones Autónomas Regionales,
                  conformarán y consolidarán sus bancos de programas y proyectos
                  de inversión.
                  <br />
                  <br />
                  Es de resaltar, la contribución que realiza el BPPI-CAR a los
                  procesos de planeación, presupuesto, seguimiento, control y
                  evaluación de resultados a la inversión realizada con recursos
                  del presupuesto anual de rentas y gastos de la Corporación y
                  el cumplimiento de las metas trazadas en sus instrumentos de
                  planificación. Para tal efecto, existirá un único Banco de
                  Programas y Proyectos de Inversión BPPI-CAR.
                </div>
              </CardPopUp>
            </div>

            <div className="py-4 mt-4">
              <CardPopUp
                title="Estructura Banco de Programas y Proyectos de Inversión - CAR"
                description="Conocela aquí"
                iconSrc={"./logo_car_corto.svg"}
              >
                <Image
                  src={images("./BPPI_estructura.png")}
                  alt="Estructura banco de proyectos"
                />
              </CardPopUp>
            </div>

            <div className="py-4 mt-4">
              <CardPopUp
                title="Objetivo"
                description="Conocelo aquí"
                iconSrc={"./logo_car_corto.svg"}
              >
                <div
                  style={{
                    maxWidth: "1000px",
                    maxHeight: "700px",
                    overflow: "scroll",
                  }}
                >
                  <h2 className="text-acua text-center">
                    Objetivo General del Banco de Programas y Proyectos de
                    Inversión BPPI-CAR
                  </h2>
                  <div className="pb-5 fs-responsive-m">
                    Fortalecer la Formulación, Programación de Inversión,
                    Ejecución y seguimiento del gasto de inversión pública en la
                    Corporación Autónoma Regional de Cundinamarca CAR.
                  </div>
                  <h3 className="text-acua text-center">
                    Objetivos Específicos del Banco de Programas y Proyectos de
                    Inversión BPPI-CAR
                  </h3>
                  <div className="fs-responsive-m">
                    <b>a. </b>Articular y consolidar la información de la
                    inversión pública de la Corporación con todos sus
                    instrumentos de planificación.
                    <br />
                    <br /> <b>b. </b> Disponer de información veraz y oportuna
                    para el proceso de seguimiento, control y evaluación de los
                    proyectos de inversión de la Corporación.
                    <br />
                    <br /> <b>c. </b> Establecer los mecanismos de coordinación
                    entre las dependencias, entidades, sociedad civil y
                    organizaciones partícipes de la estructura de formulación,
                    programación de inversión y ejecución y seguimiento del
                    gasto de inversión pública en la Corporación.
                    <br />
                    <br />
                    <b>d. </b> Definir la metodología, procesos y procedimientos
                    para la formulación y estructuración de programas y
                    proyectos de inversión.
                  </div>
                </div>
              </CardPopUp>
            </div>

            <div className="py-4 mt-4">
              <CardPopUp
                title="Alcance"
                description="Conocelo aquí"
                iconSrc={"./logo_car_corto.svg"}
              >
                <div
                  style={{
                    maxWidth: "1000px",
                    maxHeight: "700px",
                    overflow: "scroll",
                  }}
                  className=" fs-responsive-m"
                >
                  <p>
                    El alcance del Banco de Programas y Proyectos de Inversión
                    BPPI-CAR, está contemplado desde el registro de los
                    Programas, Proyectos, Metas, Actividades y Acciones conforme
                    a la metodología y procedimientos establecidos, continua con
                    la verificación de requisitos, y termina con el seguimiento
                    en cada una de sus etapas.
                  </p>
                  <p>
                    Así mismo, se garantiza el debido tránsito de los proyectos
                    y las acciones en la estructura de formulación, programación
                    de inversión y ejecución y seguimiento del gasto de
                    inversión, garantizando la calidad, pertinencia y eficiencia
                    de la inversión pública, encaminada al ejercicio de sus
                    competencias como autoridad ambiental de la jurisdicción.
                  </p>
                </div>
              </CardPopUp>
            </div>
            <TitleCar>
              <b>Funciones</b>
            </TitleCar>
            <ol type="a" className="py-5 fs-responsive-m">
              <li>
                Establecer los roles, procedimientos e instancias que
                interactúan durante el debido tránsito de los proyectos.
              </li>
              <br />
              <li>
                Realizar la verificación de requisitos para ejecución de los
                proyectos de acuerdo con los lineamientos de la Oficina Asesora
                de Planeación OAP.{" "}
              </li>
              <br />
              <li>
                Registrar los programas, proyectos y acciones de inversión de la
                entidad, previo cumplimiento de los requisitos definidos para
                tal fin.{" "}
              </li>
              <br />
              <li>
                Servir como uno de los instrumentos para realizar seguimiento en
                las etapas de inversión y ejecución y operación y mantenimiento
                ejecución de los proyectos de inversión de la Corporación.{" "}
              </li>
              <br />
              <li>
                Garantizar la disponibilidad y flujo de información de los
                proyectos de inversión pública de la Corporación.{" "}
              </li>
              <br />
              <li>
                Monitorear la información referente al avance en la ejecución de
                los proyectos inversión de la Corporación.
              </li>
              <br />
              <li>
                g. Brindar capacitación, asistencia técnica y/o transferencia de
                conocimiento a las dependencias, entidades territoriales y
                organizaciones en todos los temas referentes a la estructura de
                formulación, programación de inversión y ejecución y seguimiento
                del gasto de inversión del proyecto de inversión.
              </li>
              <br />
            </ol>

            <TitleCar>
              <b>Equipo Evaluador</b>
            </TitleCar>
            <Grid2 className="px-5">
              <Image src={images("./EquipoEvaluador/img1.png")}></Image>
              {/*<Image src={images("./EquipoEvaluador/img1.png")}></Image>
              <Image src={images("./EquipoEvaluador/img1.png")}></Image>
              <Image src={images("./EquipoEvaluador/img1.png")}></Image>*/}
            </Grid2>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default QuienesSomos;
